import React, { useEffect } from 'react';
import { TrackingProvider, PageView } from '@justgiving/react-tracking';
import { loadClient } from '@justgiving/chrome';
import analytics from '../../utils/analytics';
import useBasePageQuery from '../../hooks/useBasePageQuery';

const baseTrackingData = {};

const Page: React.FunctionComponent = ({ children }) => {
  const basePageData = useBasePageQuery();
  const headerimage = basePageData?.data?.page?.branding?.headerImage;

  useEffect(() => {
    loadClient({
      headerVariant: headerimage ? 'branded' : 'consumer',
      footerVariant: headerimage ? 'branded' : 'full',
    });
  }, [headerimage]);

  return (
    <TrackingProvider
      analytics={analytics}
      defaultTrackingData={{
        page_id: basePageData?.data?.page?.legacyId,
        event_label: basePageData?.data?.page?.legacyId,
        event_category: basePageData?.data?.page?.type,
      }}
    >
      <PageView trackingData={baseTrackingData}>{children}</PageView>
    </TrackingProvider>
  );
};

export default Page;
